import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { RsfMainSBaseComponent } from '../rsf-main-s-base/rsf-main-s-base.component';
import { Tag } from 'src/app/common/enumerations/enumerations';
import { RSFConfiguration } from '../../rsf.service';

@Component({
  selector: 'rsf-main-s2',
  templateUrl: './rsf-main-s2.component.html',
  styleUrls: ['./rsf-main-s2.component.scss']
})
export class RsfMainS2Component extends RsfMainSBaseComponent implements OnChanges {

  minorAmendmentIDs: number[] = [];

  /**
   * Recomputes approval state and identifies Minor Amendment workflow groups for display.
   * @param changes Angular input changes that triggered the approval refresh.
   */
  override ngOnChanges(changes: SimpleChanges): void {
    // Preserve Minor Amendment presentation after the amendment is completed and no longer active.
    this.minorAmendmentIDs = this.rsf?.rsfAmendments
      ?.filter(amendment => amendment.isMinorAmendment && !!amendment.wfAmendmentID)
      .map(amendment => amendment.wfAmendmentID!) ?? [];

    const allSignatures = this.rsf?.wfTable?.wfTableLocal?.wfSectionLocals.flatMap(s => s.wfSignatures);
    const submitSignature = allSignatures?.find(s => s?.code == Tag.SUBMIT);

    // Deactivate work approval signatures if the user is the submitter
    const submitterID = submitSignature?.signedBy?.id;
    const workApprovalsSignatures = allSignatures?.filter(s => s?.wfTaskLocal.wfStepLocal?.code == Tag.WORK_APPROVALS);
    workApprovalsSignatures?.forEach(s => s!.disabled = this.currentUser?.id == submitterID);

    // Deactivate amendment approval signatures if the user is the submitter or if safety controls have not changed
    const sectionNumber = RSFConfiguration.AmendmentApprovalsSectionNumber;
    const activateSignatures = allSignatures?.filter(s => s?.sectionNumber == sectionNumber && s?.code == Tag.ACTIVE_FORM);
    this.rsf?.rsfAmendments?.forEach(a => {
      activateSignatures?.filter(s => s?.wfAmendmentID == a.wfAmendmentID).forEach(s => s!.enabled = a.safetyControlsChanged);
    });
  }
}
